export default class FieldValidator {

  validate(input) {
    const value = input.value.replace(/^\s+|\s+$/g, ''),
      isRequired = input.getAttribute('required') != null,
      isEmpty = value === ''

    if (isRequired && isEmpty) {
      return false
    }

    return this.validateValue(value, input)
  }

}